export default {
  INVOICES: false,
  CONTRACTS: true,
  SPOTIFY_EXPORT: false,
  EVENT_TEMPLATES: true,
  TIME_OFF: true,
  INTEGRATIONS: false,
  CUSTOM_GENRES: true
};